import { render, staticRenderFns } from "./ModalPickearComponent.vue?vue&type=template&id=90f5da80&"
import script from "./ModalPickearComponent.vue?vue&type=script&lang=js&"
export * from "./ModalPickearComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports